import React from 'react';

const ResultsTableWrapper = ({ results, type, onClickHandler, searchList = false, children }) => {
    const handleViewAll = e => {
        e.preventDefault();

        onClickHandler(type);
    };

    const handleBackToResults = e => {
        e.preventDefault();

        onClickHandler(false);
    };

    if (results.hits.length > 0) {
        return (
            <section className="content-section content-section--no-padding-bottom">
                <div className="container">
                    <header className="content-header">
                        <h2 className="content-header__small-title sanomat">{type}</h2>
                        <div className="content-header__button">
                            {searchList ? (
                                <a
                                    className="button button--outline button--full"
                                    href="#"
                                    onClick={handleBackToResults}>
                                    Back to results
                                </a>
                            ) : (
                                <a className="button button--outline button--full" href="#" onClick={handleViewAll}>
                                    View all
                                </a>
                            )}
                        </div>
                    </header>
                    {children}
                </div>
            </section>
        );
    }

    return <></>;
};

export default ResultsTableWrapper;
